var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.clickable ? 'button' : 'span',{tag:"component",staticClass:"gl-z-1 gl-flex gl-items-center gl-justify-center gl-rounded-full gl-border-0 gl-text-sm gl-font-bold gl-text-neutral-0",class:{
    'comment-indicator gl-border-0 gl-bg-transparent gl-p-0': _vm.isNewNote,
    'js-image-badge design-note-pin gl-bg-[var(--gl-status-brand-icon-color)]': !_vm.isNewNote,
    resolved: _vm.isResolved,
    inactive: _vm.isInactive,
    draft: _vm.isDraft,
    'on-image gl-border-2 gl-border-solid gl-border-neutral-0 gl-shadow-[0_2px_4px_var(--gl-color-alpha-dark-8),0_0_1px_var(--gl-color-alpha-dark-24)]':
      _vm.isOnImage,
    'gl-absolute': _vm.position,
    'gl-h-7 gl-w-7': _vm.size === 'md',
    'small gl-h-6 gl-w-6': _vm.size === 'sm',
  },style:(_vm.position),attrs:{"aria-label":_vm.pinLabel,"type":_vm.clickable ? 'button' : undefined},on:{"click":function($event){_vm.clickable && _vm.$emit('click', $event)}}},[(_vm.isNewNote)?_c('gl-icon',{staticClass:"gl-rounded-full gl-border-2 gl-border-solid gl-border-neutral-0 gl-bg-neutral-0 gl-text-neutral-950",attrs:{"name":"image-comment-dark","size":32}}):[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }